import React from 'react';
import { Link } from 'react-router-dom';

import { API_ROOT } from '../../settings';
import { getMailToLink } from '../../utils';

class HomePage extends React.Component {
  state = {
    error: null
  }

  componentDidMount() {
    document.body.className = 'login';
    const myNav = navigator.userAgent.toLowerCase();
    const IE = (myNav.indexOf('msie') != -1) ? parseInt(myNav.split('msie')[1]) : false;
    if (IE && IE < 10) {
      alert('Your browser is not supported. Please update your browser or download Google Chrome for optimal performance.');
    }
    if (this.props.location) {
      const query = this.props.location.search;
      const params = new URLSearchParams(query);
      const error = params.get('error');
      this.setState({ error });
    }
  }

  render() {
    return (
      <div>
        <div id="container">
          <header role="banner" id="header--puma">
            <div className="container">
              <div className="logo">
                <Link to="/">
                  <img src="/assets/img/UTSouthwestern-Medical-Group.svg" alt="UTSouthwestern Medical Center" />
                </Link>
              </div>
            </div>
          </header>
          <div id="main" role="main">
            <div className="login_form">
              <h1>
                <span className="cap">P</span>rofile<br />
                <span className="cap">U</span>pdate<br />
                <span className="cap">M</span>anagement<br />
                <span className="cap">A</span>dmin
              </h1>
              <a href={API_ROOT + '/api/puma/saml2/?sso'}><button className="login_submit">Login</button></a>

              {this.state.error && <div className="errorMsg"><p>{this.state.error}</p></div>}
              <p>For members of the UT Southwestern Medical Group or UT Southwestern Pediatric Group, please login with your employee ID and password. If you are a provider support staff/liaison or have trouble logging in, please email <a href={ getMailToLink('digital@utsouthwestern.edu', 'Login Page', 'Trouble Loggin In') }>digital@utsouthwestern.edu</a>.</p>

            </div>
            <Link to="/admin">
              <img className="shield-admin" src="/assets/img/icon-shield.svg" alt="admin" />
            </Link>
          </div>
        </div>
      </div>
    )
  }
}

export default HomePage;



// WEBPACK FOOTER //
// ./src/components/pages/HomePage.jsx